<template>
    <main class="landing-container">
        <section class="slogan">
            <div class="slogan-img"></div>
            <div class="main-title-wrapper">
                <div class="main-title">{{ $t('lp-investor19') }}</div>

                <div class="learn-more-btn" v-on:click="videoModalVisible = true">{{ $t('lp-investor8') }}</div>
            </div>
        </section>
        <section class="boxes">
            <div class="box box1">
                <div class="box-icon"></div>
                <div class="box-title">{{ $t('lp-investor2') }}</div>
                <div class="box-text-it" v-if="$i18n.locale === 'it'">
                    <ul>
                        <li>Accesso diretto a centinaia di vini pregiati ed etichette esclusive</li>
                        <li>Vini acquistati direttamente dai produttori a prezzi competitivi</li>
                        <li>Costi trasparenti e basse commissioni</li>
                    </ul>
                </div>
                <div class="box-text" v-else>
                    <ul>
                        <li>Direct and easy access to hundreds of wines and vintages.</li>
                        <li>All wines sourced directly from the producers guaranteeing best price.</li>
                        <li>Low commissions and transparent fees.</li>
                    </ul>
                </div>
            </div>
            <div class="box box2">
                <div class="box-icon"></div>
                <div class="box-title">{{ $t('lp-investor4') }}</div>
                <div class="box-text-it" v-if="$i18n.locale === 'it'">
                    <ul>
                        <li>Collezioni accuratamente selezionate che permettono di arricchire facilmente la tua cantina</li>
                        <li>Esperienza intuitiva per collezionare vini liberamente e senza stress</li>
                        <li>Acquisto e vendita del vino in tempo reale tramite il nostro Live Market</li>
                    </ul>
                </div>
                <div class="box-text" v-else>
                    <ul>
                        <li>Carefully selected Collections makes it easy to build your wine cellar.</li>
                        <li>Our live market allows you to buy and sell wine in real time.</li>
                    </ul>
                </div>
            </div>
            <div class="box box3">
                <div class="box-icon"></div>
                <div class="box-title">{{ $t('lp-investor6') }}</div>
                <div class="box-text-it" v-if="$i18n.locale === 'it'">
                    <ul>
                        <li>Provenienza ed autenticità di tutti i vini garantita</li>
                        <li>Vini conservati in modo sicuro ed in sospensione d’IVA nei nostri depositi</li>
                        <li>Transazioni registrate su blockchain garantendo la tracciabilità</li>
                    </ul>
                </div>
                <div class="box-text" v-else>
                    <ul>
                        <li>All wines are sourced directly from the producer.</li>
                        <li>Provenance and authenticity of all wines guaranteed.</li>
                        <li>Each transaction is recorded on blockchain.</li>
                    </ul>
                </div>
            </div>
        </section>

        <!-- Video -->
        <v-dialog v-model="videoModalVisible" class="video-dialog">
            <iframe v-if="$i18n.locale === 'it'" width="100%" height="100%" src="/assets/it_video.mp4" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            <iframe v-else width="100%" height="100%" src="https://blog.vindome.net/wp-content/uploads/2021/11/vindome.mp4" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            <a href="#" v-on:click="videoModalVisible = false" class="close-video-modal"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0" y="0" viewBox="0 0 32 32" xml:space="preserve" width="20" height="20"><g id="icon-x-close"><path fill="#ffffff" d="M30.3448276,31.4576271 C29.9059965,31.4572473 29.4852797,31.2855701 29.1751724,30.980339 L0.485517241,2.77694915 C-0.122171278,2.13584324 -0.104240278,1.13679247 0.52607603,0.517159487 C1.15639234,-0.102473494 2.17266813,-0.120100579 2.82482759,0.477288136 L31.5144828,28.680678 C31.9872448,29.1460053 32.1285698,29.8453523 31.8726333,30.4529866 C31.6166968,31.0606209 31.0138299,31.4570487 30.3448276,31.4576271 Z" id="Shape"></path> <path fill="#ffffff" d="M1.65517241,31.4576271 C0.986170142,31.4570487 0.383303157,31.0606209 0.127366673,30.4529866 C-0.12856981,29.8453523 0.0127551942,29.1460053 0.485517241,28.680678 L29.1751724,0.477288136 C29.8273319,-0.120100579 30.8436077,-0.102473494 31.473924,0.517159487 C32.1042403,1.13679247 32.1221713,2.13584324 31.5144828,2.77694915 L2.82482759,30.980339 C2.51472031,31.2855701 2.09400353,31.4572473 1.65517241,31.4576271 Z" id="Shape"></path></g></svg></a>
        </v-dialog>
        <!-- End Video -->

        <section class="lp-section2">
            <div class="lp-section2-text">{{ $t('lp-investor23') }}</div>
            <nuxt-link class="lp-section2-btn ga4-reg-btn" :to="localePath('/register')">{{ $t('lp-investor10') }}</nuxt-link>
        </section>

        <section class="how-section">
            <h2 class="home-title">{{ $t('top-collections') }}</h2>
            <HomeTopCollections class="home-collections-container" :collections-list="topCollectionItems"></HomeTopCollections>

            <h2 class="home-title">{{ $t('more-collections') }}</h2>
            <HomeMoreCollections class="home-more-collections" :collections-list="restCollectionsItems" :useSlider="true"></HomeMoreCollections>

            <div class="mobileapp-container people-notice-wrapper" v-if="mobileCheck !== null">
                <h2 class="home-title-wine">{{ $t('app7') }}</h2>

                <swiper :options="mobileCheck ? swiperOptionMobile : swiperOption">
                    <swiper-slide v-for="(item, index) in $i18n.locale === 'it' ? swiperDataIT : swiperData" :key="index">
                        <div v-on:click="showPrivacy(item.article)" class="article-text">
                            <div :class="'testimonial-logo logo-' + item.name"></div>
                            <div class="testimonial-info" v-html="item.value"></div>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>
        </section>
    </main>
</template>

<script>
    import HomeTopCollections from "../components/home/HomeTopCollections";
    import HomeMoreCollections from "../components/home/HomeMoreCollections";
    import {AOrders} from "~/store/actions";
    import {mapGetters} from "vuex";
    import {GOrders, GCommon} from "~/store/getters";
    import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css'

    export default {
        name: "LpInvestor",
        head: {
            title: 'Opportunities for wine lovers | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                }
            ],
            bodyAttrs: {
                class: 'page-landing-investor'
            }
        },
        components: { Swiper, SwiperSlide, HomeTopCollections, HomeMoreCollections },
        directives: {
            swiper: directive
        },
        computed: {
            ...mapGetters({
                collectionsList: GOrders.GET_COLLECTIONS,
                topCollectionsList: GOrders.GET_TOP_COLLECTIONS,
                mobileCheck: GCommon.GET_MOBILE_VERSION
            }),
            topCollectionIds() {
                let _list = [];
                this.topCollectionsList.forEach(el => {
                    _list.push(el.collectionId)
                });
                return _list
            }
        },
        data () {
            return {
                videoModalVisible: false,
                topCollectionItems: [],
                restCollectionsItems: [],
                collectionItems: [],
                swiperOption: {
                    slidesPerView: 3,
                    spaceBetween: 60,
                    loop: false
                },
                swiperOptionMobile: {
                    slidesPerView: 1,
                    spaceBetween: 60,
                    loop: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    autoplay: {
                        delay: 2500,
                        disableOnInteraction: false
                    }
                },
                swiperData: [
                    {
                        name: 'vice',
                        article: 'vice',
                        value: 'How to Invest in Wine If You\'re Not a Millionaire'
                    },
                    {
                        name: 'startup',
                        article: 'startup',
                        value: 'Vindome also offers beginners the opportunity to invest in wine as an alternative investment'
                    },
                    {
                        name: 'rssmagazine',
                        article: 'rssmagazine',
                        value: 'Is it better to invest in sneakers or fine wines?'
                    }
                ],
                swiperDataIT: [
                    {
                        name: 'vice',
                        article: 'vice',
                        value: 'Come diventare ricchi - o almeno provarci - con il vino'
                    },
                    {
                        name: 'businessinsider',
                        article: 'BusinessInsider',
                        value: 'Vindome, l’app per investire sui vini pregiati: un mercato da 5,1 miliardi di dollari'
                    },
                    {
                        name: 'larepubblica',
                        article: 'larepubblica',
                        value: 'Vindome, a app che apre al portafoglio dei giovani.'
                    }
                ]
            }
        },
        methods: {
            showPrivacy: function(article){
                if (article === 'dagospia') {
                    window.open('https://m.dagospia.com/ma-quale-bitcoin-il-vero-investimento-sicuro-e-il-vinoarriva-vindome-l-app-per-fare-254689');
                } else if (article === 'jamesmagazine') {
                    window.open('https://www.jamesmagazine.it/news/vindome-lapp-investe-sui-vini-pregiati/');
                } else if (article === 'vice') {
                    window.open('https://www.vice.com/it/article/k7anww/guadagnare-con-il-vino');
                } else {
                    window.open(`https://vindome.net/Vindome_${article}.pdf`);
                }
            }
        },
        created() {
            this.$store.dispatch(AOrders.GET_TOP_COLLECTIONS, this.$i18n.locale);

            this.collectionItems = [];
            this.$store.dispatch(AOrders.GET_COLLECTIONS, this.$i18n.locale).then(() => {
                this.collectionItems = this.collectionsList;

                let homeCtrl = this;
                let total = 0;
                let totalMore = 0;
                this.collectionItems.forEach(item => {
                    if (homeCtrl.topCollectionIds.indexOf(item.id) < 0 && total < 6 && !item.isGiftDelivery) {
                        total += 1;
                    }
                    if (homeCtrl.topCollectionIds.indexOf(item.id) > -1) {
                        homeCtrl.topCollectionItems.push(item)
                    }
                    if (homeCtrl.topCollectionIds.indexOf(item.id) < 0 && totalMore < 6 && !item.isGiftDelivery) {
                        homeCtrl.restCollectionsItems.push(item);
                        totalMore += 1;
                    }
                })
            });
        }
    }
</script>

<style scoped>
    .home-title {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-size: 19px;
        line-height: 23px;
        font-weight: 600;
        color: #303030;
        margin-bottom: 18px;
        position: relative;
    }
    .slogan {
        height: 560px;
        position: relative;
    }
    .slogan-img {
        background: url('../assets/landing/lp-back.jpg') no-repeat center top;
        background-size: cover;
        width: 100%;
        height: 100%;
    }
    .main-title-wrapper {
        position: absolute;
        left: calc(50% - 1032px/2);
        top: calc(50% - 102px/2);
    }
    .main-title {
        width: 1032px;
        height: 102px;
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: 42px;
        line-height: 51px;
        display: flex;
        align-items: center;
        text-align: center;
        color: #FFFFFF;
    }
    .learn-more-btn {
        display: block;
        padding: 8px 16px;
        width: 140px;
        height: 40px;
        background: #CEA94B;
        border-radius: 4px;
        margin: 32px auto 0;
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 24px;
        text-align: center;
        text-transform: uppercase;
        color: #FFFFFF;
    }
    .learn-more-btn:hover {
        cursor: pointer;
    }
    .boxes {
        position: relative;
        width: 1174px;
        top: -40px;
        margin: 0 auto;
    }
    .box {
        display: inline-block;
        padding: 32px;
        width: calc((100% - 88px) / 3);
        height: 330px;
        background: #FFFFFF;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.16);
        border-radius: 8px;
        vertical-align: top;
    }
    .box2 {
        margin: 0 40px;
    }
    .box-icon {
        width: 80px;
        height: 80px;
        margin: 0 auto;
    }
    .box1 .box-icon {
        background: url('../assets/landing/investor/lp1.png') no-repeat center top;
        background-size: cover;
    }
    .box2 .box-icon {
        background: url('../assets/landing/investor/lp2.png') no-repeat center top;
        background-size: cover;
    }
    .box3 .box-icon {
        background: url('../assets/landing/investor/lp3.png') no-repeat center top;
        background-size: cover;
    }
    .box-title {
        position: static;
        height: 22px;
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        line-height: 22px;
        text-align: center;
        color: rgba(0, 0, 0, 0.88);
        margin-top: 24px;
    }
    .box-text {
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 17px;
        text-align: left;
        color: rgba(0, 0, 0, 0.64);
        flex: none;
        order: 1;
        align-self: stretch;
        flex-grow: 0;
        margin: 8px 0;
    }
    .box-text-it {
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 17px;
        text-align: left;
        color: rgba(0, 0, 0, 0.64);
        flex: none;
        order: 1;
        align-self: stretch;
        flex-grow: 0;
        margin: 8px 0;
    }
    .box-text-it ul,
    .box-text ul {
        padding-left: 0;
        list-style-position: outside;
    }
    .lp-section2 {
        width: 1174px;
        margin: 0 auto;
        padding: 40px;
        background: linear-gradient(88.98deg, #00304D 0%, #003F66 52.08%, #004F7F 100%);
        border-radius: 8px;
    }
    .how-section {
        width: 1174px;
        margin: 40px auto 0;
    }
    .lp-section2-text {
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        line-height: 22px;
        text-align: center;
        color: #FFFFFF;
        width: 699px;
        margin: 0 auto;
    }
    .lp-section2-btn {
        display: block;
        width: 148px;
        height: 40px;
        background: #CEA94B;
        border-radius: 4px;
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 40px;
        text-align: center;
        text-transform: uppercase;
        color: #FFFFFF;
        margin: 48px auto 0;
        text-decoration: none;
    }


    .howto-text-wrapper {
        width: 1174px;
        margin: 70px auto 0;
    }
    .howto-text-wrapper > .row {
        margin-bottom: 50px;
    }
    .howto-text-wrapper > .row .col {
        padding: 0;
        position: relative;
    }
    .howto-text-wrapper > .row .col.col-sm-9 {
        max-width: 660px;
    }
    .how-icon {
        width: 100%;
        height: 100%;
        display: block;
    }
    .icon-shadow {
        position: absolute;
        width: 72px;
        height: 8px;
        left: calc(50% - 72px/2 - 0.5px);
        bottom: 0;
        background: #505050;
        filter: blur(16px);
    }
    .cart {
        background: url('../assets/how/cart.png') no-repeat center 12px;
    }
    .currency {
        background: url('../assets/how/currency.png') no-repeat center 12px;
    }
    .store {
        background: url('../assets/how/store-icon.png') no-repeat center 12px;
    }
    .delivery {
        background: url('../assets/how/Subtract.png') no-repeat center 12px;
    }
    .howto-title {
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 24px;
        line-height: 29px;
        color: rgba(0, 0, 0, 0.88);
        margin: 16px 0;
    }
    .howto-text {
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 17px;
        color: rgba(0, 0, 0, 0.64);
        margin: 16px 0;
    }
    .mobileapp-testimonials {
        background: #F6F6F6;
        height: 488px;
    }
    .mobileapp-testimonials .contactus-title2 {
        padding-top: 44px;
        margin-top: 0;
    }
    .testimonial-text {
        max-width: 1024px;
        margin: 0 auto;
        font-size: 17px;
        line-height: 22px;
    }
    .testimonial-name {
        color: #303030;
        font-weight: 700;
        font-size: 14px;
    }
    .testimonial-logo {
        width: 161px;
        height: 89px;
        margin: 0 auto 19px;
    }
    .logo-decanter {
        background: url('../assets/app/decanter.png') no-repeat center;
    }
    .logo-winespectator {
        background: url('../assets/app/winespectator.png') no-repeat center;
    }
    .logo-saveur {
        background: url('../assets/app/saveur.png') no-repeat center;
    }

    .logo-larepubblica {
        background: url('../assets/app/larepubblica.png') no-repeat center;
        background-size: contain;
    }
    .logo-ilgiornale {
        background: url('../assets/app/ilgiornale.png') no-repeat center;
        background-size: contain;
    }
    .logo-businessinsider {
        background: url('../assets/app/businessinsider.png') no-repeat center;
        background-size: contain;
    }
    .logo-cosmopolitan {
        background: url('../assets/app/cosmopolitan.png') no-repeat center;
        background-size: contain;
    }
    .logo-digitalclub {
        background: url('../assets/app/digitalclub.png') no-repeat center;
        background-size: contain;
    }
    .logo-mixerplanet {
        background: url('../assets/app/mixerplanet.png') no-repeat center;
        background-size: contain;
    }
    .logo-igrandivini {
        background: url('../assets/app/igrandivini.png') no-repeat center;
        background-size: contain;
    }
    .logo-vanityfair {
        background: url('../assets/app/vanityfair.svg') no-repeat center;
        background-size: contain;
    }
    .logo-winenews {
        background: url('../assets/app/winenews.png') no-repeat center;
        background-size: contain;
    }
    .logo-dagospia {
        background: url('../assets/app/dagospia.png') no-repeat center;
        background-size: contain;
    }
    .logo-vice {
        background: url('../assets/app/vice.svg') no-repeat center;
        background-size: contain;
    }
    .logo-rssmagazine {
        background: url('../assets/app/rss.png') no-repeat center;
        background-size: contain;
    }
    .logo-startup {
        background: url('../assets/app/startup.png') no-repeat center;
        background-size: contain;
    }
    .logo-jamesmagazine {
        background: url('../assets/app/jamesmagazine.png') no-repeat center;
        background-size: contain;
    }
    .testimonial-info {
        font-weight: 400;
        font-size: 25px;
        line-height: 120%;
        text-align: center;
        color: #303030;
    }
    .mobileapp-container {
        max-width: 1366px;
        margin: 0 auto;
    }
    .home-title-wine {
        text-align: center;
        font-weight: 400;
        font-size: 40px;
        line-height: 47px;
        margin: 80px auto 40px;
    }

    @media (max-width: 767px) {
        .main-title {
            top: 150px;
            width: 100%;
            font-size: 26px;
            line-height: 30px;
            left: 0;
        }
        .boxes {
            top: 40px;
            width: 100%;
        }
        .box {
            width: calc(100% - 30px);
            margin: 0 15px;
        }
        .box2 {
            margin: 40px 15px;
        }
        .lp-section2,
        .lp-section2-text,
        .how-section {
            width: 100%;
        }
        .slogan {
            height: 370px;
        }
        .howto-text-wrapper > .row  {
            padding: 15px;
            margin: 0;
            display: block;
        }
        .howto-text-wrapper > .row .col-sm-3.col {
            width: 100%;
            height: 138px;
            margin-bottom: 35px;
        }
        .main-title-wrapper {
            top: 100px;
            width: 100%;
            left: 0;
        }
        .main-title {
            width: 100%;
            font-size: 26px;
            line-height: 30px;
        }
        .lp-section2 {
            border-radius: 0;
            margin-top: 70px;
        }
    }
</style>
<style>
  .page-landing-investor .v-main {
    padding-top: 0 !important;
  }
    .page-landing-investor .logo {
        display: block;
        margin: 0 auto;
        width: 206px;
    }
    .page-landing-investor .logo img {
        margin-top: 30px;
        width: 206px;
    }
    .page-landing-investor .theme--dark.v-sheet.header-toolbar.v-app-bar--is-scrolled .logo img {
        margin-top: 10px;
    }
    .page-landing-investor .nav-second-row,
    .page-landing-investor .nav-first-row-right .header-login-btn {
        display: none;
    }
    .page-landing-investor .nav-first-row-right {
        position: absolute;
        top: 30px;
        right: 40px;
    }
    .page-landing-investor .theme--dark.v-sheet.header-toolbar.v-app-bar--is-scrolled .nav-first-row-right {
        top: 20px;
    }
    .page-landing-investor .v-dialog {
        width: 90%;
        margin: 0;
        position: relative;
        overflow: visible;
    }
    .close-video-modal {
        display: block;
        position: absolute;
        right: 0;
        top: -25px;
        text-decoration: none;
        font-size: 20px;
        font-weight: bold;
        color: #fff;
    }
    .swiper-container {
        margin: 0 auto;
        position: relative;
        overflow: hidden;
        list-style: none;
        padding: 0;
        z-index: 1;
        height: 300px;
        width: 100%;
    }
    .show-mobile .swiper-container {
        height: 360px;
    }
    .people-notice-wrapper .swiper-container {
        height: 330px;
        margin-bottom: 50px;
    }
    .swiper-wrapper {
        position: relative;
        width: 100%;
        height: 100%;
        z-index: 1;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        transition-property: -webkit-transform;
        transition-property: transform;
        transition-property: transform,-webkit-transform;
        box-sizing: content-box;
    }

    .swiper-container-no-flexbox .swiper-slide {
        float: left
    }

    .swiper-container-vertical>.swiper-wrapper {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column
    }

    .swiper-wrapper {
        position: relative;
        width: 100%;
        height: 100%;
        z-index: 1;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        transition-property: -webkit-transform;
        transition-property: transform;
        transition-property: transform,-webkit-transform;
        box-sizing: content-box
    }

    .swiper-container-android .swiper-slide,.swiper-wrapper {
        -webkit-transform: translateZ(0);
        transform: translateZ(0)
    }

    .swiper-container-multirow>.swiper-wrapper {
        -ms-flex-wrap: wrap;
        flex-wrap: wrap
    }

    .swiper-container-free-mode>.swiper-wrapper {
        transition-timing-function: ease-out;
        margin: 0 auto
    }

    .swiper-slide {
        -ms-flex-negative: 0;
        flex-shrink: 0;
        width: 100%;
        height: 100%;
        position: relative;
        transition-property: -webkit-transform;
        transition-property: transform;
        transition-property: transform,-webkit-transform
    }

    .swiper-slide.swiper-slide-active .testimonial-item {
        border-right: 1px solid #F0F0F0;
        padding-left: 0;
        padding-right: 45px;
    }

    .show-mobile .swiper-slide.swiper-slide-active .testimonial-item {
        border-right: 0;
        padding-right: 0;
    }

    .swiper-invisible-blank-slide {
        visibility: hidden
    }

    .swiper-container-autoheight,.swiper-container-autoheight .swiper-slide {
        height: auto
    }

    .swiper-container-autoheight .swiper-wrapper {
        -webkit-box-align: start;
        -ms-flex-align: start;
        align-items: flex-start;
        transition-property: height,-webkit-transform;
        transition-property: transform,height;
        transition-property: transform,height,-webkit-transform
    }

    .swiper-container-3d {
        -webkit-perspective: 1200px;
        perspective: 1200px
    }

    .swiper-container-3d .swiper-cube-shadow,.swiper-container-3d .swiper-slide,.swiper-container-3d .swiper-slide-shadow-bottom,.swiper-container-3d .swiper-slide-shadow-left,.swiper-container-3d .swiper-slide-shadow-right,.swiper-container-3d .swiper-slide-shadow-top,.swiper-container-3d .swiper-wrapper {
        -webkit-transform-style: preserve-3d;
        transform-style: preserve-3d
    }

    .swiper-container-3d .swiper-slide-shadow-bottom,.swiper-container-3d .swiper-slide-shadow-left,.swiper-container-3d .swiper-slide-shadow-right,.swiper-container-3d .swiper-slide-shadow-top {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        z-index: 10
    }

    .swiper-container-3d .swiper-slide-shadow-left {
        background-image: linear-gradient(270deg,rgba(0,0,0,.5),transparent)
    }

    .swiper-container-3d .swiper-slide-shadow-right {
        background-image: linear-gradient(90deg,rgba(0,0,0,.5),transparent)
    }

    .swiper-container-3d .swiper-slide-shadow-top {
        background-image: linear-gradient(0deg,rgba(0,0,0,.5),transparent)
    }

    .swiper-container-3d .swiper-slide-shadow-bottom {
        background-image: linear-gradient(180deg,rgba(0,0,0,.5),transparent)
    }

    .swiper-container-wp8-horizontal,.swiper-container-wp8-horizontal>.swiper-wrapper {
        -ms-touch-action: pan-y;
        touch-action: pan-y
    }

    .swiper-container-wp8-vertical,.swiper-container-wp8-vertical>.swiper-wrapper {
        -ms-touch-action: pan-x;
        touch-action: pan-x
    }

    .swiper-button-next,.swiper-button-prev {
        position: absolute;
        top: 50%;
        width: 27px;
        height: 44px;
        margin-top: -22px;
        z-index: 10;
        cursor: pointer;
        background-size: 27px 44px;
        background-position: 50%;
        background-repeat: no-repeat
    }

    .swiper-button-next.swiper-button-disabled,.swiper-button-prev.swiper-button-disabled {
        opacity: .35;
        cursor: auto;
        pointer-events: none
    }

    .swiper-button-prev,.swiper-container-rtl .swiper-button-next {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z' fill='%23007aff'/%3E%3C/svg%3E");
        left: 50px;
        right: auto
    }

    .swiper-button-next,.swiper-container-rtl .swiper-button-prev {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z' fill='%23007aff'/%3E%3C/svg%3E");
        right: 50px;
        left: auto
    }

    .swiper-button-prev.swiper-button-white,.swiper-container-rtl .swiper-button-next.swiper-button-white {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z' fill='%23fff'/%3E%3C/svg%3E")
    }

    .swiper-button-next.swiper-button-white,.swiper-container-rtl .swiper-button-prev.swiper-button-white {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z' fill='%23fff'/%3E%3C/svg%3E")
    }

    .swiper-button-prev.swiper-button-black,.swiper-container-rtl .swiper-button-next.swiper-button-black {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z'/%3E%3C/svg%3E")
    }

    .swiper-button-next.swiper-button-black,.swiper-container-rtl .swiper-button-prev.swiper-button-black {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z'/%3E%3C/svg%3E")
    }

    .swiper-pagination {
        position: absolute;
        text-align: center;
        transition: opacity .3s;
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
        z-index: 10
    }

    .swiper-pagination.swiper-pagination-hidden {
        opacity: 0
    }

    .swiper-container-horizontal>.swiper-pagination-bullets,.swiper-pagination-custom,.swiper-pagination-fraction {
        bottom: 10px;
        left: 0;
        width: 100%
    }

    .carousel-wrapper {
        height: 480px;
        position: relative;
    }

    @media (max-width: 767px) {
        .swiper-container-horizontal>.swiper-pagination-bullets,.swiper-pagination-custom,.swiper-pagination-fraction {
            bottom: 0;
        }

        .page-landing-investor .nav-first-row-right {
            top: 15px;
            right: 25px;
        }
        .page-landing-investor .nav-first-row-right .my-account-nav.lang-nav {
            display: none;
        }
        .page-landing-investor .theme--dark.v-sheet.header-toolbar.v-app-bar--is-scrolled .nav-first-row-right {
            top: 25px;
        }
    }

    .swiper-pagination-bullets-dynamic {
        overflow: hidden;
        font-size: 0
    }

    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
        -webkit-transform: scale(.33);
        transform: scale(.33);
        position: relative
    }

    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {
        -webkit-transform: scale(1);
        transform: scale(1)
    }

    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {
        -webkit-transform: scale(.66);
        transform: scale(.66)
    }

    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {
        -webkit-transform: scale(.33);
        transform: scale(.33)
    }

    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {
        -webkit-transform: scale(.66);
        transform: scale(.66)
    }

    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {
        -webkit-transform: scale(.33);
        transform: scale(.33)
    }

    .swiper-pagination-bullet {
        width: 8px;
        height: 8px;
        display: inline-block;
        border-radius: 100%;
        background: #000;
        opacity: .2
    }

    button.swiper-pagination-bullet {
        border: none;
        margin: 0;
        padding: 0;
        box-shadow: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none
    }

    .swiper-pagination-clickable .swiper-pagination-bullet {
        cursor: pointer
    }

    .swiper-pagination-bullet-active {
        opacity: 1;
        background: #007aff
    }

    .swiper-container-vertical>.swiper-pagination-bullets {
        right: 10px;
        top: 50%;
        -webkit-transform: translate3d(0,-50%,0);
        transform: translate3d(0,-50%,0)
    }

    .swiper-container-vertical>.swiper-pagination-bullets .swiper-pagination-bullet {
        margin: 6px 0;
        display: block
    }

    .swiper-container-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
        top: 50%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        width: 8px
    }

    .swiper-container-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
        display: inline-block;
        transition: top .2s,-webkit-transform .2s;
        transition: transform .2s,top .2s;
        transition: transform .2s,top .2s,-webkit-transform .2s
    }

    .swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet {
        margin: 0 4px
    }

    .swiper-container-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        white-space: nowrap
    }

    .swiper-container-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
        transition: left .2s,-webkit-transform .2s;
        transition: transform .2s,left .2s;
        transition: transform .2s,left .2s,-webkit-transform .2s
    }

    .swiper-container-horizontal.swiper-container-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
        transition: right .2s,-webkit-transform .2s;
        transition: transform .2s,right .2s;
        transition: transform .2s,right .2s,-webkit-transform .2s
    }

    .swiper-pagination-progressbar {
        background: rgba(0,0,0,.25);
        position: absolute
    }

    .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
        background: #007aff;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        -webkit-transform: scale(0);
        transform: scale(0);
        -webkit-transform-origin: left top;
        transform-origin: left top
    }

    .swiper-container-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
        -webkit-transform-origin: right top;
        transform-origin: right top
    }

    .swiper-container-horizontal>.swiper-pagination-progressbar {
        width: 100%;
        height: 4px;
        left: 0;
        top: 0
    }

    .swiper-container-vertical>.swiper-pagination-progressbar {
        width: 4px;
        height: 100%;
        left: 0;
        top: 0
    }

    .swiper-pagination-white .swiper-pagination-bullet-active {
        background: #fff
    }

    .swiper-pagination-progressbar.swiper-pagination-white {
        background: hsla(0,0%,100%,.25)
    }

    .swiper-pagination-progressbar.swiper-pagination-white .swiper-pagination-progressbar-fill {
        background: #fff
    }

    .swiper-pagination-black .swiper-pagination-bullet-active {
        background: #000
    }

    .swiper-pagination-progressbar.swiper-pagination-black {
        background: rgba(0,0,0,.25)
    }

    .swiper-pagination-progressbar.swiper-pagination-black .swiper-pagination-progressbar-fill {
        background: #000
    }

    .swiper-scrollbar {
        border-radius: 10px;
        position: relative;
        -ms-touch-action: none;
        background: rgba(0,0,0,.1)
    }

    .swiper-container-horizontal>.swiper-scrollbar {
        position: absolute;
        left: 1%;
        bottom: 3px;
        z-index: 50;
        height: 5px;
        width: 98%
    }

    .swiper-container-vertical>.swiper-scrollbar {
        position: absolute;
        right: 3px;
        top: 1%;
        z-index: 50;
        width: 5px;
        height: 98%
    }

    .swiper-scrollbar-drag {
        height: 100%;
        width: 100%;
        position: relative;
        background: rgba(0,0,0,.5);
        border-radius: 10px;
        left: 0;
        top: 0
    }

    .swiper-scrollbar-cursor-drag {
        cursor: move
    }

    .swiper-zoom-container {
        width: 100%;
        height: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        text-align: center
    }

    .swiper-zoom-container>canvas,.swiper-zoom-container>img,.swiper-zoom-container>svg {
        max-width: 100%;
        max-height: 100%;
        -o-object-fit: contain;
        object-fit: contain
    }

    .swiper-slide-zoomed {
        cursor: move
    }

    .swiper-lazy-preloader {
        width: 42px;
        height: 42px;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -21px;
        margin-top: -21px;
        z-index: 10;
        -webkit-transform-origin: 50%;
        transform-origin: 50%;
        -webkit-animation: swiper-preloader-spin 1s steps(12) infinite;
        animation: swiper-preloader-spin 1s steps(12) infinite
    }

    .swiper-lazy-preloader:after {
        display: block;
        content: "";
        width: 100%;
        height: 100%;
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath id='a' stroke='%236c6c6c' stroke-width='11' stroke-linecap='round' d='M60 7v20'/%3E%3C/defs%3E%3Cuse xlink:href='%23a' opacity='.27'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(30 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(60 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(90 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(120 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(150 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.37' transform='rotate(180 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.46' transform='rotate(210 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.56' transform='rotate(240 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.66' transform='rotate(270 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.75' transform='rotate(300 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.85' transform='rotate(330 60 60)'/%3E%3C/svg%3E");
        background-position: 50%;
        background-size: 100%;
        background-repeat: no-repeat
    }

    .swiper-lazy-preloader-white:after {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath id='a' stroke='%23fff' stroke-width='11' stroke-linecap='round' d='M60 7v20'/%3E%3C/defs%3E%3Cuse xlink:href='%23a' opacity='.27'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(30 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(60 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(90 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(120 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(150 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.37' transform='rotate(180 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.46' transform='rotate(210 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.56' transform='rotate(240 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.66' transform='rotate(270 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.75' transform='rotate(300 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.85' transform='rotate(330 60 60)'/%3E%3C/svg%3E")
    }

    @-webkit-keyframes swiper-preloader-spin {
        to {
            -webkit-transform: rotate(1turn);
            transform: rotate(1turn)
        }
    }

    @keyframes swiper-preloader-spin {
        to {
            -webkit-transform: rotate(1turn);
            transform: rotate(1turn)
        }
    }

    .swiper-container .swiper-notification {
        position: absolute;
        left: 0;
        top: 0;
        pointer-events: none;
        opacity: 0;
        z-index: -1000
    }

    .swiper-container-fade.swiper-container-free-mode .swiper-slide {
        transition-timing-function: ease-out
    }

    .swiper-container-fade .swiper-slide {
        pointer-events: none;
        transition-property: opacity
    }

    .swiper-container-fade .swiper-slide .swiper-slide {
        pointer-events: none
    }

    .swiper-container-fade .swiper-slide-active,.swiper-container-fade .swiper-slide-active .swiper-slide-active {
        pointer-events: auto
    }

    .swiper-container-cube {
        overflow: visible
    }

    .swiper-container-cube .swiper-slide {
        pointer-events: none;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        z-index: 1;
        visibility: hidden;
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
        width: 100%;
        height: 100%
    }

    .swiper-container-cube .swiper-slide .swiper-slide {
        pointer-events: none
    }

    .swiper-container-cube.swiper-container-rtl .swiper-slide {
        -webkit-transform-origin: 100% 0;
        transform-origin: 100% 0
    }

    .swiper-container-cube .swiper-slide-active,.swiper-container-cube .swiper-slide-active .swiper-slide-active {
        pointer-events: auto
    }

    .swiper-container-cube .swiper-slide-active,.swiper-container-cube .swiper-slide-next,.swiper-container-cube .swiper-slide-next+.swiper-slide,.swiper-container-cube .swiper-slide-prev {
        pointer-events: auto;
        visibility: visible
    }

    .swiper-container-cube .swiper-slide-shadow-bottom,.swiper-container-cube .swiper-slide-shadow-left,.swiper-container-cube .swiper-slide-shadow-right,.swiper-container-cube .swiper-slide-shadow-top {
        z-index: 0;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden
    }

    .swiper-container-cube .swiper-cube-shadow {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background: #000;
        opacity: .6;
        -webkit-filter: blur(50px);
        filter: blur(50px);
        z-index: 0
    }

    .swiper-container-flip {
        overflow: visible
    }

    .swiper-container-flip .swiper-slide {
        pointer-events: none;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        z-index: 1
    }

    .swiper-container-flip .swiper-slide .swiper-slide {
        pointer-events: none
    }

    .swiper-container-flip .swiper-slide-active,.swiper-container-flip .swiper-slide-active .swiper-slide-active {
        pointer-events: auto
    }

    .swiper-container-flip .swiper-slide-shadow-bottom,.swiper-container-flip .swiper-slide-shadow-left,.swiper-container-flip .swiper-slide-shadow-right,.swiper-container-flip .swiper-slide-shadow-top {
        z-index: 0;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden
    }

    .swiper-container-coverflow .swiper-wrapper {
        -ms-perspective: 1200px
    }

    @media (max-width: 767px) {
        .page-landing-investor .v-application .hidden-md-and-up {
            display: none !important;
        }
        .page-landing-investor .logo,
        .page-landing-investor .logo img {
            width: 106px;
            margin: 0;
        }
        .page-landing-investor .logo {
            margin: 15px auto 0;
        }
        .page-landing-investor .swiper-container {
            height: 390px;
        }
    }
</style>
